export default "__VITE_ASSET__DTfZWAOg__"